export const SET_SUBJECTS = 'SET_SUBJECTS'
export const SET_SUBJECT = 'SET_SUBJECT'
export const SET_SUBJECT_LECTURES = 'SET_SUBJECT_LECTURES'
